<template>
  <div class="m-tabbar">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ["value"],
  computed: {}
};
</script>
<style lang="less">
.m-tabbar {
  width: 780px;
  overflow: hidden;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue